exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message[data-v-06060f12] {\n  text-align: center;\n  font-size: 1.8rem;\n  color: #324148;\n  margin-top: 200px;\n  margin-left:5%;\n  margin-right:5%;\n}\n.action[data-v-06060f12] {\n  margin-top:50px;\n  width: 150px;\n  margin-left:auto;\n  margin-right:auto;\n}\n.action-button[data-v-06060f12] {\n  width: 150px;\n  height: 40px;\n  background-color: #324148;\n  color: white;\n  font-weight: bold;\n}\n", ""]);

// exports
